import { render, staticRenderFns } from "./AddItem.vue?vue&type=template&id=113c09ec"
import script from "./AddItem.vue?vue&type=script&lang=js"
export * from "./AddItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports